export const PARTNER_CAPABILITIES = [
  { value: 'web_design', label: 'Web design' },
  { value: 'web_development', label: 'Web development' },
  { value: 'full_service_agency', label: 'Full service agency' },
  { value: 'integration_solutions', label: 'Integration solutions' },
  { value: 'ecommerce_consultant', label: 'Ecommerce consultant' },
  { value: 'email_marketing', label: 'Email marketing' },
  { value: 'freelancer', label: 'Freelancer' },
  { value: 'seo', label: 'SEO/SEM' },
  { value: 'brand', label: 'Brand' },
  { value: 'digital', label: 'Digital' },
  { value: 'other', label: 'Other' },
];

/**
 * @param {Record<string, boolean} capabilities
 * @returns {string[]}
 */
export function objectCapabilitiesToArray(capabilities) {
  return Object.entries(capabilities).reduce((acc, [capability, value]) => {
    if (value) {
      acc.push(capability);
    }

    return acc;
  }, []);
}

/**
 * @param {string[]} capabilities
 * @returns {Record<string, boolean>}
 */
export function arrayCapabilitiesToObject(capabilities) {
  return capabilities.reduce((acc, capability) => {
    acc[capability] = true;
    return acc;
  }, {});
}

/**
 * @param {Record<string, boolean>} nextCapabilities
 * @param {Record<string, boolean>} prevCapabilities
 * @returns {Record<string, boolean>}
 */
export function objectCapabilitiesUpdate(nextCapabilities, prevCapabilities) {
  const update = { ...nextCapabilities };

  for (const key of Object.keys(prevCapabilities)) {
    const value = prevCapabilities[key];

    if (value && !update[key]) {
      update[key] = false;
    }
  }

  return update;
}
